<template>
  <ul class="people_info main clearfix" v-if="data">
    <li class="head left">
      <img v-lazy="isSupportWebp(data.avatar)" :alt="data.userName" />
    </li>
    <li class="info left">
      <p class="info_title">
        <span class="name">{{ data.userName }}</span>
        <!-- 2018年年底投票称号 -->
        <span v-if="isG" class="cup" :class="{ g: isG }"></span>
        <span v-if="isA || isB || isC || isD" class="cup" :class="{ a: isA, b: isB, c: isC, d: isD }"></span>
        <span v-if="isE" class="cup" :class="{ e: isE }"></span>
        <!-- 2018年年底投票称号 over -->
        <!-- 当前用户如果是该老师就不显示关注按钮 -->
        <span class="icon_guanzhu" @click="like" v-if="!isTeacher">{{ isLike ? '已关注' : '关注' }}</span>
      </p>
      <p class="info_text">{{ data.introduce }}</p>
    </li>
    <li class="pic left" v-if="roomTopImageNormal">
      <nuxt-link target="_blank" rel="noopener" :to="roomTopImageNormal[0].link">
        <img v-lazy="isSupportWebp(roomTopImageNormal[0].image)" :alt="roomTopImageNormal[0].title" />
      </nuxt-link>
    </li>
  </ul>
</template>

<script>

import Dialog from '@/utils/Dialog'
import { Cup2018 } from '~/mixins/Cup-2018'
import Webp from '@/mixins/Webp'

export default {
  name: 'component-teacher-info',
  mixins: [Cup2018, Webp],
  created () {
    this.$store.dispatch('getAd', ['roomTopImageNormal'])
  },
  methods: {
    like () {
      if (!this.$isLogin()) {
        Dialog.login()
      } else {
        this.$store.dispatch('user/like', { teacher: this.data, isLike: this.isLike }).then(() => {
          this.$notify({
            title: '成功',
            message: this.isLike ? '关注成功' : '已取消关注',
            type: 'success'
          })
        })
      }
    }
  },
  computed: {
    data () {
      return this.$store.state.teacher.data
    },
    roomTopImageNormal () {
      return this.$store.state.adList['roomTopImageNormal']
    },
    isTeacher () {
      return this.$store.getters['teacher/isTeacher']
    },
    isLike () {
      return this.data && this.$store.getters['user/likeTeacherIds'].indexOf(this.data.id) !== -1
    }
  }
}
</script>

<style lang="less" scoped>
.people_info { height: 175px; background: #959ebd;
  .head { width: 140px; height:140px; text-align: center; line-height:60px;margin-left: 20px; margin-top:18px;background: #abb1c9; border-radius: 50%; padding-top: 10px;
    img { width: 120px; height: 120px; border-radius: 50%;}
  }
  .info { color:#f9fffb ;font-size: 14px; width: 679px; padding-top: 25px;padding-left: 23px;
    .info_title { height: 46px;
      span:not(:last-child) { margin-right: 6px; }
      .name{ font-size: 23px; }
      .icon_guanzhu {padding: 2px 18px; border: 1px solid #fff; color: #fff; cursor: pointer; border-radius: 10px; vertical-align: 0.25em;
      }
    }
    .info_text { word-wrap:break-word; width: 610px; height: 100px; font-size: 14px; line-height: 26px; }
  }
  .pic { width: 330px ; height: 100%; padding: 15px;
    a { display: block; height: 100%;
      img { width: 100%; height: 100%;}
    }
  }
}
</style>
